import './gallery.css';

export default function ProductionImages({ refId, images, headline, description }) {
  return (
    <>
      <hr className="post" />
      <div className="gallery-header">
        <h3 id={refId}>{headline}</h3>
        {description}
      </div>
      <div className="gallery-wrapper">
        {images.map((img, index) => (
          <a rel={refId} href={img.src} className="swipebox" title={img.title} key={index}>
            <img src={img.thumbnail || img.src} width="300" alt={img.alt} />
          </a>
        ))}
      </div>
    </>
  );
}
